import { render } from "./PlayerHome.vue?vue&type=template&id=6744f005&ts=true"
import script from "./PlayerHome.vue?vue&type=script&lang=ts"
export * from "./PlayerHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__